import { Route } from 'lucide-react';

import { FilteredLocationCounts } from '@/pages/dashboard/mapping/model/types';
import { typedEntries } from '@/pages/dashboard/mapping/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

import { FilteredLocation } from './filtered-location';

interface StatusInfoProps {
  filteredLocationCounts: FilteredLocationCounts;
  routeCount: number;
  showRoutes: boolean;
}

export function StatusInfo({ filteredLocationCounts, routeCount, showRoutes }: StatusInfoProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
      <div className="flex flex-wrap items-center gap-3">
        {typedEntries(filteredLocationCounts).map(([location, total]) => (
          <FilteredLocation key={location} location={location} total={total} />
        ))}
      </div>

      {routeCount > 0 && showRoutes && (
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="pl-4 border-l flex items-center gap-1 cursor-help">
              <Route className="h-4 w-4 text-orange-600" />
              <span>{routeCount} routes</span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Active transit routes: {routeCount}</p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
